module.exports = __webpack_public_path__ + "img/BINDI 3 BW.87ac45e.svg";